import React from "react";
import "./Home_custom_style.scss";
import Background from "../../assets/background.webp";
import Playstore from "../../assets/playstore.png";
import { LinkLocation } from "../../Components/LinkLocation";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { useForm } from "react-hook-form";
import { IoCloseCircleOutline } from "react-icons/io5";
import Logo from "../../assets/logo.png";

export const HomeTopSection = () => {
  const [showPopup, setShowPopup] = React.useState(false);
  const [location, setLocation] = React.useState(null);
  const [error, setError] = React.useState(null);
  const [isValid, setIsValid] = React.useState(null);
  const [country, setCountry] = React.useState("");
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const [showAlert, setShowAlert] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);

  const onSubmit = async (data) => {
    console.log("data", data);
  };
  // console.log("location", location, "error", error, "country", country);
  const requestLocationPermission = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setLocation({ latitude, longitude });
          reverseGeocode(latitude, longitude);
        },
        (errorLocation) => {
          switch (errorLocation.code) {
            case errorLocation.PERMISSION_DENIED:
              setError(
                "Permission denied. Please enable location in browser and refresh."
              );
              break;
            case errorLocation.POSITION_UNAVAILABLE:
              setError(
                "Position unavailable. Please ensure your device's location is turned on and refresh."
              );
              break;
            case errorLocation.TIMEOUT:
              setError("Request timed out. Please try again.");
              break;
            default:
              setError("An unknown error occurred.");
          }
        },
        {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0,
        }
      );
    } else {
      setError("Geolocation is not supported by your browser.");
    }
  };
  const reverseGeocode = async (latitude, longitude) => {
    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`
      );
      const data = await response.json();
      console.log("data", data);
      if (data && data.address && data.address.country_code) {
        setCountry(data.address.country_code);
      } else {
        setError("Unable to retrieve country information.");
      }
    } catch (error) {
      setError("Error fetching location data.");
    }
  };

  function validatePhoneNumber(phoneNumber, countryCode) {
    try {
      const phoneNumberObj = parsePhoneNumberFromString(
        phoneNumber,
        countryCode
      );

      if (phoneNumberObj && phoneNumberObj.isValid()) {
        const nationalNumber = phoneNumberObj.nationalNumber;

        if (countryCode === "IN" && nationalNumber.length === 10) {
          return true;
        } else {
          console.log("Invalid phone number length");
          return false;
        }
      } else {
        console.log("Invalid phone number");
      }
    } catch (error) {
      console.log("Error", error);
    }
    return false;
  }

  React.useEffect(() => {
    if (showPopup) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showPopup]);

  const validatePhoneNumber22 = (phoneNumber, countryCode) => {
    try {
      const phoneNumberObj = parsePhoneNumberFromString(
        phoneNumber,
        countryCode
      );
      // Check if the phone number is valid
      if (phoneNumberObj && phoneNumberObj.isValid()) {
        setIsValid(true);
      } else {
        setIsValid(false);
        setError("Invalid phone number format");
      }
    } catch (error) {
      setIsValid(false);
      setError("Error parsing phone number");
    }
  };

  const handleSubmited = (e) => {
    e.preventDefault();
    validatePhoneNumber22("+9715053153158", "uae");
  };
  const [deferredPrompt, setDeferredPrompt] = React.useState(null);
  const [isInstallable, setIsInstallable] = React.useState(true);

  React.useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setIsInstallable(true);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt
      );
    };
  }, []);

  const handleInstallClick = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === "accepted") {
          console.log("User accepted the install prompt");
        } else {
          console.log("User dismissed the install prompt");
        }
        setDeferredPrompt(null);
      });
    }
  };
  return (
    <div className="home-position">
      <img src={Background} alt="background_image" className="w-full" />
      {/*  <LinkLocation
        to={
          "https://play.google.com/store/apps/details?id=com.spidertechnosoft.app.xeniamobi"
        }
      > */}
      <img
        src={Playstore}
        alt="playstore-icon"
        onClick={() => setShowPopup(true)}
        className="absolute bottom-[5%] left-[9%] w-[10%] cursor-pointer"
      />
      {/* </LinkLocation> */}
      {/* <div onClick={validatePhoneNumber}>VALIDATE</div>
      {isInstallable && (
        <button onClick={handleInstallClick} className="install-button">
          Install App
        </button>
      )} */}

      {/* DEMO */}
      {showPopup ? (
        <div className="fixed top-0 bottom-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-50">
          <div className="bg-[#F8FAFF] p-4 rounded-3xl shadow-lg relative w-full sm:w-[500px]">
            <img src={Logo} className="w-48 mx-auto py-3" alt="logo" />
            <button
              type="button"
              aria-label="close popup"
              onClick={() => setShowPopup(false)}
              className="absolute top-2 right-3 cursor-pointer text-blue-600 border px-2 rounded-full text-2xl border-blue-600"
            >
              X
            </button>
            <div className="font-Avenir-medium py-2 pb-4 text-center font-medium text-3xl">
              Get it on your Mobile
            </div>
            <div className="font-Avenir-book text-center font-thin">
              Download XeniaMobi from the Play Store and simplify your billing
              process on the go!
            </div>
            <div className="flex items-center justify-center py-3 sm:p-6">
              <div className="mx-auto w-full max-w-[550px] bg-white">
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="poppins_medium flex flex-row gap-2 rounded-md outline-none shadow-md shadow-[#4180FF54] py-3 px-5 items-center">
                    <input
                      value={"+91"}
                      className="w-12 focus:outline-none border-r border-[#3627FF]"
                      disabled
                    />
                    <div className="w-full">
                      <input
                        {...register("number", { required: true })}
                        type="text"
                        placeholder="Enter Phone Number"
                        className="w-full poppins_light text-base font-thin focus:outline-none"
                      />
                      {errors.firstName?.type === "required" && (
                        <p className="m-2 text-red-600" role="alert">
                          Phone Number is required
                        </p>
                      )}
                    </div>
                  </div>
                  <p className="font-thin text-sm my-3">
                    Please enter your Phone Number.
                  </p>
                  <div className="pt-3 sm:pt-1.5">
                    <button
                      type="submit"
                      disabled={isLoading}
                      className="poppins_medium hover:shadow-form w-full rounded-md bg-blue-600 hover:bg-blue-700 py-2 px-8 text-center text-base font-semibold text-white outline-none"
                    >
                      {isLoading ? "Submitting..." : "Submit"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <div className="font-Avenir-book text-center font-thin py-3 sm:px-6">
              Make billing easy and efficient with XeniaMobi faster, smarter,
              and right at your fingertips!
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};
